<template>
    <div class="sys-title">
        <strong>{{title}}</strong>
        <slot></slot>
    </div>
</template>

<script>
export default {
    name: 'AppTitle',
    props: ['title']
}
</script>


// WEBPACK FOOTER //
// src/components/AppTitle/index.vue